import React from 'react';
import SupplierPage from '../components/SupplierPage';

const SupplierPageWrapper = () => {
  const token = localStorage.getItem('token') || '';
  return <SupplierPage token={token} />;
};

export default SupplierPageWrapper; 